import { gql } from '@apollo/client';
import { CREDIT_DECISION_PARSED_DATA_FRAGMENT } from 'modules/creditSubmission/api';

/**
 * Fetches all credit submissions for a given Dynamics Vendor Opportunity ID,
 * including the fields needed to render the Compare Approvals table.
 *
 * The caller is responsible for filtering to only "Approved" / "Pre-Approved"
 * stages before displaying results.
 */
export const GET_APPROVALS_BY_VENDOR_OPPORTUNITY_ID = gql`
  ${CREDIT_DECISION_PARSED_DATA_FRAGMENT}
  query GetApprovalsByVendorOpportunityId($voId: ID!) {
    creditSubmissionsByDynamicsVOId(id: $voId) {
      creditSubmissionId
      lenderName
      approvedAmount
      approvedRate
      stage
      decision
      contingencies
      creditDecisionParsedData {
        ...CreditDecisionParsedDataFields
      }
      proposals {
        proposalId
        status
        termLength
        monthlyPayment
        maxApprovedAmount
        docFee
        rate
        interestRate
        createdSnapshot
        createdDateTime
      }
    }
  }
`;

export const UPDATE_PARSED_DECISION = gql`
  mutation UpdateParsedDecision($input: UpdateParsedDecisionInput!) {
    updateParsedDecision(input: $input) {
      parsedDecisionId
      reviewStatus
      modifiedDateTime
      reviewNotes
      parsedData {
        decisionType
        decisionDate
        expirationDate
        approvalAmount
        invoiceAmount
        termLengthMonths
        interestRate
        dealerBuyRate
        customerRate
        apr
        monthlyPayment
        downPaymentToVendor
        minimumRequiredDownPayment
        totalDueAtSigning
        advancePaymentsCount
        daysToFirstPayment
        firstPaymentDueDate
        paymentCalculationType
        typeOfFinancing
        programName
        programDetails
        residualAmount
        balloonPayment
        irregularPayments
        dealerCommission
        applicantName
        businessName
        coBorrowerName
        underwriterName
        dealerName
        guarantorName
        conditions
        stipulations
        declineReasons
        lenderFees {
          feeName
          amount
          canBeFinanced
          description
        }
        termOptions {
          termLengthMonths
          interestRate
          monthlyPayment
          apr
          isRecommended
          description
        }
        paymentTiers {
          months
          monthlyPayment
          description
        }
      }
    }
  }
`;
